import { ShapeIcon } from "@flash-tecnologia/hros-web-ui-v2";
import styled, { css } from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  overflow: auto;
  border-radius: ${({ theme }) => theme.borders.radius.l}
    ${({ theme }) => theme.borders.radius.l} 0 0;
  background: ${({ theme }) => theme.colors.secondary[99]};
  border: ${({ theme }) => theme.colors.secondary[90]} solid 1px;
`;

export const IconWrapper = styled.div<{
  isFirst?: boolean;
  isLast?: boolean;
  isListItem?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    width: 1px;
    background-color: ${({ theme, isListItem }) =>
      isListItem ? theme.colors.neutral[90] : theme.colors.secondary[80]};
    z-index: -1;

    ${({ isFirst, isLast }) => {
      if (isFirst)
        return css`
          top: 50%;
          bottom: 0;
        `;
      if (isLast)
        return css`
          top: 0;
          bottom: 50%;
        `;
      return css`
        top: 0;
        bottom: 0;
      `;
    }}
  }
`;

export const StyledShapeIcon = styled(ShapeIcon)`
  margin: 0 ${({ theme }) => theme.spacings.xs};
  padding: ${({ theme }) => theme.spacings.xs5};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  & > *:not(${Header}) {
    border-left: ${({ theme }) => theme.colors.neutral[90]} solid 1px;
    border-right: ${({ theme }) => theme.colors.neutral[90]} solid 1px;
  }

  & > :last-child {
    border: ${({ theme }) => theme.colors.neutral[90]} solid 1px;
    border-top: unset;
    border-radius: 0 0 ${({ theme }) => theme.borders.radius.l}
      ${({ theme }) => theme.borders.radius.l};
  }
`;

export const TextContainer = styled.div`
  padding: ${({ theme }) => theme.spacings.s} 0;
  flex-grow: 1;
`;
